import { ReactComponent as ArrowDownIcon } from "../../../../../assets/icons/arrow-down.svg";
import "../../../../../css/CashflowModeller2/Buttons/Arrow.css";

/**
 * ArrowDown component renders a down arrow icon button.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {boolean} props.isDisabled - If true, disables the button and applies a disabled style.
 * @param {function} props.onClick - Callback function to handle click events.
 *
 * @returns {JSX.Element} The rendered ArrowDown icon button.
 */
const ArrowDown = ({ isDisabled, onClick }) => {
  return (
    <div
      className={`arrowDown-icon ${isDisabled ? "disabled" : ""}`}
      onClick={onClick}
    //   style={{
    //     pointerEvents: isDisabled ? "none" : "auto",
    //     cursor: "pointer",
    //   }}
    >
      <ArrowDownIcon />
    </div>
  );
};

export default ArrowDown;
